// Fiche produit Maison Fianchetto : points de galerie, barre d'achat collante, date de livraison, « vu récemment ».
(() => {
  /* 21/10 (audit final, accord cliente « fais gaffe que ce soit pas faux ») : jours fériés de France ET de Pologne
     (le fournisseur expédie de Pologne, la commande lui est transmise de France) : un jour férié dans l'un des deux pays
     n'est pas un jour ouvré. Calculés pour toute année (Pâques par l'algorithme grégorien), aucune liste à tenir à jour. */
  const mfFerie = window.mfFerie || (window.mfFerie = (() => {
    const cache = {};
    const key = (d) => d.getMonth() + 1 + '-' + d.getDate();
    const build = (y) => {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      const paques = new Date(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
      const plus = (n) => { const x = new Date(paques); x.setDate(x.getDate() + n); return key(x); };
      // France : 1/1, lundi de Pâques, 1/5, 8/5, Ascension, lundi de Pentecôte, 14/7, 15/8, 1/11, 11/11, 25/12
      // Pologne : 1/1, 6/1, lundi de Pâques, 1/5, 3/5, Fête-Dieu, 15/8, 1/11, 11/11, 24/12 (depuis 2025), 25/12, 26/12
      return new Set(['1-1', '1-6', '5-1', '5-3', '5-8', '7-14', '8-15', '11-1', '11-11', '12-24', '12-25', '12-26', plus(1), plus(39), plus(50), plus(60)]);
    };
    return (d) => (cache[d.getFullYear()] ||= build(d.getFullYear())).has(key(d));
  })());
  /* ---------- Date de livraison estimée (jours ouvrés, lundi-vendredi) ---------- */
  const addBusinessDays = (from, days) => {
    const d = new Date(from);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6 && !mfFerie(d)) added += 1;
    }
    return d;
  };
  const fmt = (d) => d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });

  if (!customElements.get('mf-delivery-date')) {
    customElements.define(
      'mf-delivery-date',
      class extends HTMLElement {
        connectedCallback() {
          const min = parseInt(this.dataset.min, 10);
          const max = parseInt(this.dataset.max, 10) || min;
          if (!min) return;
          const now = new Date();
          const a = fmt(addBusinessDays(now, min));
          const b = fmt(addBusinessDays(now, max));
          this.textContent = min === max ? `Livraison estimée le ${a}` : `Livraison estimée entre le ${a} et le ${b}`;
        }
      }
    );
  }

  /* ---------- Frise Commande › Expédition › Livraison (19/10) ----------
     Heure de Paris. Avant l'heure limite un jour ouvré : expédition le jour même, sinon le jour ouvré suivant.
     Livraison comptée à partir du jour d'expédition (le plus prudent). Jours fériés FR + PL exclus (21/10). */
  if (!customElements.get('mf-ship-steps')) {
    const parisToday = () => {
      const p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
        .formatToParts(new Date())
        .forEach((x) => { p[x.type] = x.value; });
      return { date: new Date(+p.year, +p.month - 1, +p.day), hour: +p.hour % 24 };
    };
    const workday = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !mfFerie(d);
    const wd = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short' });
    const mo = (d) => d.toLocaleDateString('fr-FR', { month: 'short' });
    customElements.define(
      'mf-ship-steps',
      class extends HTMLElement {
        connectedCallback() {
          const min = parseInt(this.dataset.min, 10) || 2;
          const max = parseInt(this.dataset.max, 10) || min;
          const cutoff = parseInt(this.dataset.cutoff, 10) || 13;
          const { date: today, hour } = parisToday();
          const sameDay = workday(today) && hour < cutoff;
          const ship = sameDay ? today : addBusinessDays(today, 1);
          const set = (k, t) => { const el = this.querySelector(`[data-ship="${k}"]`); if (el) el.textContent = t; };
          set('order', sameDay ? `aujourd’hui avant ${cutoff} h` : 'aujourd’hui');
          const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
          // 19/10 (cliente) : « expédié demain matin »
          set('out', sameDay ? 'aujourd’hui' : (ship.getTime() === tomorrow.getTime() ? 'demain' : ship.toLocaleDateString('fr-FR', { weekday: 'long' })));
          const a = addBusinessDays(ship, min);
          const b = addBusinessDays(ship, max);
          const range = a.getMonth() === b.getMonth()
            ? `du ${wd(a)} ${a.getDate()} au ${wd(b)} ${b.getDate()} ${mo(b)}`
            : `du ${wd(a)} ${a.getDate()} ${mo(a)} au ${wd(b)} ${b.getDate()} ${mo(b)}`;
          set('in', range);
          // ligne unique sous le bouton d'achat (bloc « mf_delivery »)
          const outWord = sameDay ? 'aujourd’hui' : ship.getTime() === tomorrow.getTime() ? 'demain' : ship.toLocaleDateString('fr-FR', { weekday: 'long' });
          set('line', sameDay ? `Commandez avant ${cutoff} h : expédié aujourd’hui` : `Commandez maintenant : expédié ${outWord}`);
          // 19/10 soir (cliente) : plus de dates sous le bouton ; elles restent dans « Livraison, retours et garantie »
          set('eta', `Livraison en ${min} à ${max} jours ouvrés`);
        }
      }
    );
  }

  /* ---------- Barre d'achat collante ---------- */
  if (!customElements.get('mf-sticky-atc')) {
    customElements.define(
      'mf-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          const section = this.dataset.section;
          const form = document.getElementById(this.dataset.form);
          const mainButton = form && form.querySelector('[name="add"]');
          this.button = this.querySelector('button');
          this.priceEl = this.querySelector('[data-price]');
          if (!mainButton) return;

          const toggle = (visible) => {
            this.classList.toggle('is-visible', visible);
            this.setAttribute('aria-hidden', visible ? 'false' : 'true');
            this.button.tabIndex = visible ? 0 : -1;
            document.body.classList.toggle('mf-has-sticky-atc', visible);
          };
          // visible seulement quand le bouton principal est passé au-dessus de l'écran
          // (rév. 30) aussi au défilement : certains navigateurs ne déclenchent pas l'observateur
          const check = () => {
            const btn = form.querySelector('[name="add"]') || mainButton;
            toggle(btn.getBoundingClientRect().bottom < 0);
          };
          window.addEventListener('scroll', check, { passive: true });
          // 19/10 (retour cliente : barre absente en défilant sur téléphone) : deux déclencheurs de plus,
          // le défilement au doigt et l'observateur du bouton principal
          document.addEventListener('touchmove', check, { passive: true });
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(check, { threshold: [0, 1] }).observe(mainButton);
          }
          check();

          // synchronise prix et disponibilité avec le bloc prix / bouton principal (changement de variante)
          const sync = () => {
            const price = document.querySelector(`#price-${section} .price-item--regular, #price-${section} .price-item--last`);
            if (price) this.priceEl.textContent = price.textContent.trim();
            const btn = form.querySelector('[name="add"]');
            if (btn) {
              this.button.disabled = btn.disabled;
              const label = btn.querySelector('span');
              if (label) this.button.textContent = label.textContent.trim();
            }
          };
          const priceBox = document.getElementById(`price-${section}`);
          if (priceBox) new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true });
          new MutationObserver(sync).observe(form, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
        }
      }
    );
  }

  /* ---------- Points sous la galerie (mobile) ----------
     Reconstruits quand la galerie change (choix d'une couleur : seules ses photos restent). */
  const pad = (n) => String(n).padStart(2, '0');
  const buildDots = (viewer) => {
    const list = viewer.querySelector('.product__media-list');
    const slides = list ? [...list.querySelectorAll('.product__media-item')] : [];
    viewer.querySelector('.mf-gallery-dots')?.remove();
    viewer.classList.toggle('mf-gallery--single', slides.length < 2); // une seule photo : pas de flèches
    if (slides.length < 2) return;
    // Jusqu'à 6 photos : des points ; au-delà : un trait de progression court + compteur « 3 / 21 »
    const compact = slides.length > 6;
    const dots = document.createElement('div');
    dots.className = 'mf-gallery-dots' + (compact ? ' mf-gallery-dots--compact' : '');
    dots.setAttribute('aria-hidden', 'true');
    if (compact) {
      dots.innerHTML =
        '<span class="mf-gallery-dots__track"><span class="mf-gallery-dots__bar"></span></span>' +
        '<span class="mf-gallery-dots__count"><b>01</b> / ' + pad(slides.length) + '</span>';
    } else {
      slides.forEach(() => dots.append(document.createElement('span')));
    }
    viewer.append(dots);
    viewer._mfSync();
  };
  document.querySelectorAll('[id^="GalleryViewer-"]').forEach((viewer) => {
    const list = viewer.querySelector('.product__media-list');
    if (!list) return;
    const slidesNow = () => [...list.querySelectorAll('.product__media-item')];
    viewer._mfSync = () => {
      const slides = slidesNow();
      if (!slides.length) return;
      const index = Math.min(Math.round(list.scrollLeft / (slides[0].offsetWidth || 1)), slides.length - 1);
      slides.forEach((s, i) => s.classList.toggle('mf-current', i === index));
      const dots = viewer.querySelector('.mf-gallery-dots');
      if (!dots) return;
      if (dots.classList.contains('mf-gallery-dots--compact')) {
        dots.style.setProperty('--mf-gal-p', index / Math.max(slides.length - 1, 1));
        dots.querySelector('b').textContent = pad(index + 1);
      } else {
        [...dots.children].forEach((d, i) => d.classList.toggle('is-active', i === index));
      }
    };
    let ticking = false;
    list.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          viewer._mfSync();
          ticking = false;
        });
      },
      { passive: true }
    );
    buildDots(viewer);

    /* Carrousel en boucle (téléphone) : après la dernière photo, on revient à la première */
    // on compare à la dernière / première photo (la liste a quelques pixels de plus que ses photos)
    const edge = (i) => {
      const s = slidesNow();
      return s.length ? s[i < 0 ? s.length - 1 : 0].getBoundingClientRect() : null;
    };
    const atEnd = () => {
      const r = edge(-1);
      return !!r && r.right <= list.getBoundingClientRect().right + 10;
    };
    const atStart = () => {
      const r = edge(0);
      return !!r && r.left >= list.getBoundingClientRect().left - 10;
    };
    const goTo = (left) => list.scrollTo({ left, behavior: 'smooth' });
    const mobile = window.matchMedia('(max-width: 749px)');
    // 19/10 (refonte, retours cliente : galerie « trop sensible », puis « le mouvement est bizarre, pas assez rapide ») :
    // sur téléphone, la photo suit le doigt quand le geste est nettement horizontal, puis se cale vite (0,28 s) sur la
    // photo suivante ou précédente (en boucle) ; un geste vertical fait seulement défiler la page.
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    let anim = 0;
    const animateTo = (to) => {
      cancelAnimationFrame(anim);
      const from = list.scrollLeft;
      const t0 = performance.now();
      list.classList.add('mf-gal-drag');
      const step = (now) => {
        const k = Math.min(1, (now - t0) / 280);
        list.scrollLeft = from + (to - from) * ease(k);
        if (k < 1) anim = requestAnimationFrame(step);
        else list.classList.remove('mf-gal-drag');
      };
      anim = requestAnimationFrame(step);
    };
    const nearestIndex = () => {
      const sl = slidesNow();
      const lr = list.getBoundingClientRect();
      let cur = 0;
      let best = Infinity;
      sl.forEach((el, i) => {
        const d = Math.abs(el.getBoundingClientRect().left - lr.left);
        if (d < best) { best = d; cur = i; }
      });
      return cur;
    };
    let drag = null;
    list.addEventListener(
      'touchstart',
      (e) => {
        if (!mobile.matches || e.touches.length !== 1) return;
        cancelAnimationFrame(anim);
        const t = e.touches[0];
        drag = { x: t.clientX, y: t.clientY, l: list.scrollLeft, t: Date.now(), dir: null, idx: nearestIndex() };
      },
      { passive: true }
    );
    list.addEventListener(
      'touchmove',
      (e) => {
        if (!drag) return;
        const t = e.touches[0];
        const dx = t.clientX - drag.x;
        const dy = t.clientY - drag.y;
        if (!drag.dir) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          drag.dir = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
          if (drag.dir === 'x') list.classList.add('mf-gal-drag');
        }
        if (drag.dir !== 'x') return;
        if (e.cancelable) e.preventDefault();
        list.scrollLeft = drag.l - dx;
      },
      { passive: false }
    );
    const endDrag = (e) => {
      if (!drag) return;
      const d = drag;
      drag = null;
      if (d.dir !== 'x') return;
      const x = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : d.x;
      const dx = x - d.x;
      const v = dx / Math.max(1, Date.now() - d.t);
      const sl = slidesNow();
      if (!sl.length) return;
      let n = d.idx;
      if (dx < -35 || v < -0.3) n = d.idx + 1;
      else if (dx > 35 || v > 0.3) n = d.idx - 1;
      if (n >= sl.length) n = 0;
      if (n < 0) n = sl.length - 1;
      const lr = list.getBoundingClientRect();
      animateTo(list.scrollLeft + (sl[n].getBoundingClientRect().left - lr.left));
    };
    list.addEventListener('touchend', endDrag, { passive: true });
    list.addEventListener('touchcancel', endDrag, { passive: true });
    // flèches posées sur la photo : la suivante après la dernière ramène à la première (et inversement)
    if ('enableSliderLooping' in viewer) {
      viewer.enableSliderLooping = true;
      viewer.querySelectorAll('.slider-buttons .slider-button').forEach((b) => b.removeAttribute('disabled'));
      viewer.addEventListener(
        'click',
        (e) => {
          const b = e.target.closest('.slider-buttons .slider-button');
          if (!b) return;
          if (b.name === 'next' && atEnd()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            goTo(0);
          } else if (b.name === 'previous' && atStart()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            goTo(list.scrollWidth);
          }
        },
        true
      );
    }
  });

  /* ---------- Combinaison inexistante (ex. Roi : Marron n'existe qu'en Grand) ----------
     Appelé par product-info.js quand le choix ne correspond à aucune variante : après un changement de couleur,
     on passe sur la 1re taille qui existe dans cette couleur, au lieu d'afficher « Non disponible ». */
  window.mfFixCombination = (root) => {
    const sets = [...(root.querySelector('variant-selects')?.querySelectorAll('fieldset') || [])];
    for (const fs of sets.slice(1)) {
      const checked = fs.querySelector('input:checked');
      if (!checked || checked.dataset.mfExists !== '0') continue;
      const next = fs.querySelector('input[data-mf-exists="1"]:not(.disabled)') || fs.querySelector('input[data-mf-exists="1"]');
      if (!next) return false;
      next.checked = true;
      next.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  };

  /* ---------- Choix épuisé ou inexistant : bascule sur la version disponible la plus proche ----------
     Ex. plateau noyer : 52 cm n'est disponible qu'« Avec » coordonnées. Un clic sur 52 cm coche « Avec »
     avant que Dawn ne charge la variante, avec une petite phrase pour le signaler. */
  document.addEventListener(
    'change',
    (e) => {
      const vs = e.target.closest('variant-selects');
      if (!vs) return;
      let all;
      try {
        all = JSON.parse(vs.querySelector('[data-mf-variants]')?.textContent || '[]');
      } catch {
        return;
      }
      const groups = [...vs.querySelectorAll('fieldset, .product-form__input--dropdown')];
      if (groups.length < 2 || !all.length) return;
      const idx = groups.findIndex((g) => g.contains(e.target));
      if (idx < 0) return;
      const read = (g) => (g.querySelector('input:checked') || g.querySelector('select'))?.value;
      const chosen = groups.map(read);
      const exact = all.find((v) => v.o.every((x, i) => x === chosen[i]));
      if (exact && exact.a) return;
      // version disponible avec la valeur cliquée, en changeant le moins d'options possible (les premières d'abord gardées)
      let best = null;
      let bestCost = Infinity;
      all.forEach((v) => {
        if (!v.a || v.o[idx] !== chosen[idx]) return;
        const cost = v.o.reduce((s, x, i) => s + (x === chosen[i] ? 0 : 10 - i), 0);
        if (cost < bestCost) {
          best = v;
          bestCost = cost;
        }
      });
      if (!best) return;
      const changed = [];
      groups.forEach((g, i) => {
        if (i === idx || best.o[i] === chosen[i]) return;
        const name = g.querySelector('legend, label.form__label')?.textContent.trim().replace(/:.*$/s, '') || '';
        const radio = [...g.querySelectorAll('input[type="radio"]')].find((r) => r.value === best.o[i]);
        const select = g.querySelector('select');
        if (radio) radio.checked = true;
        else if (select) {
          [...select.options].forEach((o) => {
            o.selected = o.value === best.o[i];
            o.toggleAttribute('selected', o.selected);
          });
        }
        changed.push(name ? `${name.toLowerCase()} « ${best.o[i]} »` : `« ${best.o[i]} »`);
      });
      if (!changed.length) return;
      let note = vs.parentElement.querySelector('.mf-variant-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'mf-variant-note';
        note.setAttribute('role', 'status');
        vs.after(note);
      }
      const clickedName = groups[idx].querySelector('legend, label.form__label')?.textContent.trim().replace(/:.*$/s, '') || '';
      note.textContent = `${clickedName ? clickedName + ' ' : ''}« ${chosen[idx]} » : disponible en ${changed.join(', ')}. Choix ajusté.`;
      note.classList.add('is-on');
      clearTimeout(note._t);
      note._t = setTimeout(() => note.classList.remove('is-on'), 5000);
    },
    true
  );

  /* ---------- Changement de couleur : vignettes, points et pagination suivent la nouvelle galerie ---------- */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const gallery = document.querySelector(`media-gallery[id$="${data.sectionId}"]`) || document.querySelector('media-gallery');
      if (!gallery || !data.html) return;
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      const thumbs = gallery.querySelector('[id^="GalleryThumbnails-"]');
      const dst = thumbs?.querySelector('ul');
      const src = data.html.querySelector('[id^="GalleryThumbnails-"] ul');
      const key = (ul) => [...ul.querySelectorAll('[data-target]')].map((li) => li.dataset.target).join(',');
      if (dst && src && key(dst) !== key(src)) {
        dst.innerHTML = src.innerHTML;
        dst.querySelectorAll('[data-target]').forEach((li) => {
          li.querySelector('button')?.addEventListener('click', gallery.setActiveMedia.bind(gallery, li.dataset.target, false));
        });
        thumbs.resetPages?.();
        const cur = dst.querySelector('[aria-current]')?.closest('[data-target]');
        if (cur) thumbs.slider?.scrollTo({ top: 0, left: 0 });
      }
      if (viewer) {
        viewer.resetPages?.();
        buildDots(viewer);
      }
      // Téléphone : à chaque changement de photos (couleur…), on remonte sur la galerie.
      // Dawn ne le fait qu'au 1er choix (son défilement se perd ensuite) : on le fait nous-mêmes, à chaque fois.
      const photoKey = () => {
        const list = viewer?.querySelector('.product__media-list');
        const active = list?.querySelector('.is-active');
        return list ? [...list.children].map((li) => li.dataset.mediaId).join(',') + '|' + (active?.dataset.mediaId || '') : '';
      };
      const k = photoKey();
      if (window.matchMedia('(max-width: 749px)').matches && k !== gallery._mfKey) {
        // un seul défilement, doux, juste après la mise à jour des photos (Dawn ne défile plus sur téléphone)
        setTimeout(() => {
          const header = document.querySelector('.section-header');
          const offset = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
          const top = gallery.getBoundingClientRect().top + window.scrollY - offset;
          if (Math.abs(window.scrollY - top) > 8) window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
        }, 30);
      }
      gallery._mfKey = k;

    });
    // état de départ : un changement de taille qui ne change pas les photos ne fait pas défiler
    document.querySelectorAll('media-gallery').forEach((g) => {
      const list = g.querySelector('[id^="GalleryViewer-"] .product__media-list');
      const active = list?.querySelector('.is-active');
      if (list) g._mfKey = [...list.children].map((li) => li.dataset.mediaId).join(',') + '|' + (active?.dataset.mediaId || '');
    });
  }

  /* ---------- Flèches de galerie sur ordinateur : passent à la vignette suivante / précédente ---------- */
  document.querySelectorAll('[id^="GalleryThumbnails-"]').forEach((thumbs) => {
    const viewer = document.getElementById(thumbs.id.replace('GalleryThumbnails-', 'GalleryViewer-'));
    const buttons = [...thumbs.querySelectorAll('.thumbnail')];
    if (!viewer || buttons.length < 2 || viewer.querySelector('.mf-gallery-arrows')) return;
    const wrap = document.createElement('div');
    wrap.className = 'mf-gallery-arrows';
    const make = (dir, label, path) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'mf-gallery-arrow';
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 20 10" aria-hidden="true"><path d="' + path + '" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
      b.addEventListener('click', () => {
        const list = [...thumbs.querySelectorAll('.thumbnail')];
        const i = Math.max(0, list.findIndex((t) => t.getAttribute('aria-current') === 'true'));
        const next = list[(i + dir + list.length) % list.length];
        if (next) next.click();
      });
      return b;
    };
    wrap.append(make(-1, 'Photo précédente', 'M20 5H2M6 1L2 5l4 4'), make(1, 'Photo suivante', 'M0 5h18M14 1l4 4-4 4'));
    viewer.append(wrap);
  });

  /* ---------- Tablette (iPad, 750 px et plus) : glisser la grande photo passe à la suivante / précédente ----------
     27/10 (audit affichage) : à partir de 750 px la galerie n'a plus de défilement au doigt ; seuls les flèches et
     les vignettes marchaient. Un glissement nettement horizontal appuie sur la flèche ; un geste vertical fait défiler la page. */
  if (navigator.maxTouchPoints > 0 || 'ontouchstart' in window) {
    document.querySelectorAll('[id^="GalleryViewer-"]').forEach((viewer) => {
      let start = null;
      viewer.addEventListener(
        'touchstart',
        (e) => {
          start = !window.matchMedia('(max-width: 749px)').matches && e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
        },
        { passive: true }
      );
      viewer.addEventListener(
        'touchend',
        (e) => {
          if (!start || !e.changedTouches[0]) return;
          const dx = e.changedTouches[0].clientX - start.x;
          const dy = e.changedTouches[0].clientY - start.y;
          start = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
          // nos flèches (vignettes) d'abord, celles de Dawn sinon
          const btn =
            viewer.querySelector(`.mf-gallery-arrow[aria-label="Photo ${dx < 0 ? 'suivante' : 'précédente'}"]`) ||
            viewer.querySelector(dx < 0 ? '.slider-button--next' : '.slider-button--prev');
          if (btn) btn.click();
        },
        { passive: true }
      );
      viewer.addEventListener('touchcancel', () => (start = null), { passive: true });
    });
  }

  /* ---------- Repères Plateau / Pièces / Rangement : l'indice ne doit jamais élargir la page ----------
     27/10 (audit affichage) : sur une ligne quand il tient (consigne du 19/10), à la ligne seulement s'il déborde. */
  const fitKeyspecs = () => {
    document.querySelectorAll('.mf-keyspecs').forEach((ks) => {
      ks.classList.remove('mf-keyspecs--wrap');
      if (ks.offsetWidth && ks.scrollWidth > ks.clientWidth + 1) ks.classList.add('mf-keyspecs--wrap');
    });
  };
  fitKeyspecs();
  let fitTimer = 0;
  window.addEventListener('resize', () => {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(fitKeyspecs, 150);
  });
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-selects, .product-form__input')) window.setTimeout(fitKeyspecs, 450);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitKeyspecs);

  /* ---------- Caractéristiques par taille : suit la variante choisie ---------- */
  const syncVariantSpecs = () => {
    const input = document.querySelector('product-info input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (!input) return;
    document.querySelectorAll('[data-mf-variant]').forEach((el) => {
      el.hidden = el.dataset.mfVariant !== String(input.value);
    });
  };
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-selects, .product-form__input')) window.setTimeout(syncVariantSpecs, 400);
  });
  const idInput = document.querySelector('product-info input[name="id"]');
  if (idInput) new MutationObserver(syncVariantSpecs).observe(idInput, { attributes: true, attributeFilter: ['value'] });

  /* ---------- Visionneuse photo (remplace la fenêtre de Dawn) ---------- */
  const gallery = document.querySelector('[id^="GalleryViewer-"]');
  if (gallery) {
    const big = (img) => {
      const src = img.currentSrc || img.src;
      try {
        const u = new URL(src, window.location.href);
        u.searchParams.set('width', '2000');
        return u.toString();
      } catch (e) {
        return src;
      }
    };
    const items = () =>
      [...gallery.querySelectorAll('.product__media-item')]
        .map((li) => li.querySelector('.product__media img'))
        .filter(Boolean)
        .map((img) => ({ src: big(img), alt: img.alt || '' }));

    let box, imgEl, counter, index = 0, list = [], startX = null;
    const build = () => {
      box = document.createElement('div');
      box.className = 'mf-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Photos du produit');
      box.innerHTML =
        '<button type="button" class="mf-lightbox__close" aria-label="Fermer"><span></span></button>' +
        '<button type="button" class="mf-lightbox__nav mf-lightbox__nav--prev" aria-label="Photo précédente"><svg viewBox="0 0 20 10" aria-hidden="true"><path d="M20 5H2M6 1L2 5l4 4" fill="none" stroke="currentColor" stroke-width="1.2"/></svg></button>' +
        '<figure class="mf-lightbox__stage"><img class="mf-lightbox__img" alt=""></figure>' +
        '<button type="button" class="mf-lightbox__nav mf-lightbox__nav--next" aria-label="Photo suivante"><svg viewBox="0 0 20 10" aria-hidden="true"><path d="M0 5h18M14 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.2"/></svg></button>' +
        '<p class="mf-lightbox__count" aria-live="polite"></p>';
      document.body.append(box);
      imgEl = box.querySelector('.mf-lightbox__img');
      counter = box.querySelector('.mf-lightbox__count');
      box.querySelector('.mf-lightbox__close').addEventListener('click', close);
      box.querySelector('.mf-lightbox__nav--prev').addEventListener('click', () => show(index - 1));
      box.querySelector('.mf-lightbox__nav--next').addEventListener('click', () => show(index + 1));
      box.addEventListener('click', (e) => {
        if (e.target === box) close();
      });
      imgEl.addEventListener('click', (e) => {
        // zoom au toucher / au clic, centré sur le point touché
        const r = imgEl.getBoundingClientRect();
        imgEl.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
        box.classList.toggle('is-zoomed');
      });
      box.addEventListener('pointerdown', (e) => {
        if (!box.classList.contains('is-zoomed')) startX = e.clientX;
      });
      box.addEventListener('pointerup', (e) => {
        if (startX === null) return;
        const dx = e.clientX - startX;
        startX = null;
        if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
      });
      document.addEventListener('keydown', (e) => {
        if (!box.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') show(index + 1);
        if (e.key === 'ArrowLeft') show(index - 1);
      });
    };
    // 19/10 : photos préchargées (les voisines d'abord, puis toutes) ; la photo affichée ne change
    // qu'une fois la suivante prête, pour éviter l'écran vide pendant le chargement de la grande image.
    const cache = {};
    const load = (src) => {
      if (!cache[src]) {
        const im = new Image();
        im.decoding = 'async';
        cache[src] = new Promise((res) => {
          im.onload = im.onerror = () => (im.decode ? im.decode().catch(() => {}).then(res) : res());
        });
        im.src = src;
      }
      return cache[src];
    };
    let showToken = 0;
    const show = (i, instant) => {
      index = (i + list.length) % list.length;
      const item = list[index];
      const token = ++showToken;
      box.classList.remove('is-zoomed');
      counter.textContent = index + 1 + ' / ' + list.length;
      box.classList.add('is-loading');
      (instant ? Promise.resolve() : load(item.src)).then(() => {
        if (token !== showToken) return; // on a déjà demandé une autre photo
        box.classList.remove('is-loading');
        imgEl.classList.remove('is-in');
        imgEl.src = item.src;
        imgEl.alt = item.alt;
        requestAnimationFrame(() => imgEl.classList.add('is-in'));
      });
      [1, -1, 2].forEach((d) => load(list[(index + d + list.length) % list.length].src));
    };
    let lastFocus = null;
    const open = (i) => {
      list = items();
      if (!list.length) return;
      if (!box) build();
      lastFocus = document.activeElement;
      box.classList.add('is-open');
      document.documentElement.classList.add('mf-lock');
      show(i, true); // 1re photo : affichée tout de suite, elle se charge sous les yeux
      box.querySelector('.mf-lightbox__close').focus();
      window.setTimeout(() => list.forEach((x) => load(x.src)), 600);
    };
    const close = () => {
      box.classList.remove('is-open', 'is-zoomed');
      document.documentElement.classList.remove('mf-lock');
      if (lastFocus) lastFocus.focus();
    };
    document.addEventListener(
      'click',
      (e) => {
        const toggle = e.target.closest('.product__media-toggle');
        if (!toggle || !gallery.contains(toggle)) return;
        e.preventDefault();
        e.stopPropagation();
        const li = toggle.closest('.product__media-item');
        const all = [...gallery.querySelectorAll('.product__media-item')].filter((x) => x.querySelector('.product__media img'));
        open(Math.max(0, all.indexOf(li)));
      },
      true
    );
  }

  /* ---------- Galerie : chargement des photos dans l'ordre où on les regarde ----------
     19/10 (retour cliente : écran blanc et longue attente en faisant défiler) : avant, toutes les photos (jusqu'à 36)
     partaient en même temps et une photo pas encore chargée était cachée. Maintenant : file d'attente, 3 photos à la fois,
     en partant de la photo affichée ; les 2 suivantes passent devant à chaque changement ; une photo en cours de chargement
     reste visible (elle se dessine), l'animation de fondu n'est jouée que si la photo est déjà prête. */
  document.querySelectorAll('.product__media-list').forEach((list) => {
    const items = [...list.querySelectorAll('.product__media-item')].filter((it) => it.querySelector('.media img'));
    const imgOf = (it) => it.querySelector('.media img');
    const ready = (img) => img.complete && img.naturalWidth > 0;
    const queue = [];
    let running = 0;
    const pump = () => {
      while (running < 3 && queue.length) {
        const img = queue.shift();
        if (ready(img)) continue;
        running += 1;
        const done = () => { running -= 1; pump(); };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        img.loading = 'eager';
        if (ready(img)) { img.removeEventListener('load', done); done(); }
      }
    };
    const prioritize = (idx, n) => {
      for (let k = n; k >= 1; k -= 1) {
        const it = items[idx + k];
        if (!it) continue;
        const img = imgOf(it);
        const q = queue.indexOf(img);
        if (q > -1) queue.splice(q, 1);
        if (!ready(img)) queue.unshift(img);
      }
      pump();
    };
    const start = () => {
      const cur = Math.max(0, items.findIndex((it) => it.classList.contains('is-active')));
      // d'abord les suivantes, puis les précédentes, puis le reste
      // 19/10 (vitesse sur téléphone) : seulement les 4 suivantes et la précédente au départ ; les autres se chargent
      // au fil de la navigation (prioritize), au lieu des 36 photos d'un coup (1,7 Mo sur la fiche du Sénateur)
      const order = [...items.slice(cur, cur + 5), ...items.slice(Math.max(0, cur - 1), cur).reverse()];
      order.forEach((it) => { const img = imgOf(it); if (!ready(img)) queue.push(img); });
      pump();
    };
    if (document.readyState === 'complete') setTimeout(start, 100);
    else window.addEventListener('load', () => setTimeout(start, 100), { once: true });

    const play = (item) => {
      const img = imgOf(item);
      if (!img) return;
      prioritize(items.indexOf(item), 2);
      item.classList.remove('mf-in', 'mf-wait');
      if (!ready(img)) return; // pas de fondu sur une photo qui arrive : elle s'affiche au fil du chargement
      void item.offsetWidth;
      item.classList.add('mf-in');
    };
    new MutationObserver((mutations) =>
      mutations.forEach((m) => {
        const el = m.target;
        const wasActive = (m.oldValue || '').split(' ').includes('is-active');
        if (el.classList.contains('product__media-item') && el.classList.contains('is-active') && !wasActive) play(el);
        // téléphone : la photo affichée porte mf-current (glissement au doigt)
        const wasCurrent = (m.oldValue || '').split(' ').includes('mf-current');
        if (el.classList.contains('product__media-item') && el.classList.contains('mf-current') && !wasCurrent) prioritize(items.indexOf(el), 2);
      })
    ).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  });

  /* ---------- Vu récemment : mémorise le produit consulté ---------- */
  const current = document.querySelector('[data-mf-product-handle]');
  if (current) {
    try {
      const KEY = 'mf-recent';
      const handle = current.dataset.mfProductHandle;
      const list = JSON.parse(localStorage.getItem(KEY) || '[]').filter((h) => h !== handle);
      list.unshift(handle);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
    } catch (e) {
      /* stockage indisponible : la rubrique « vu récemment » reste simplement vide */
    }
  }
})();

/* ---------- Description en onglets : chaque intertitre (h2/h3) devient un onglet ---------- */
(() => {
  let uid = 0;
  const build = (desc) => {
    if (desc.dataset.mfTabs) return;
    const heads = [...desc.children].filter((el) => /^H[23]$/.test(el.tagName));
    if (heads.length < 2) return;
    desc.dataset.mfTabs = '1';
    const id = `mf-desc-${(uid += 1)}`;
    const wrap = document.createElement('div');
    wrap.className = 'mf-desc-tabs';
    const list = document.createElement('div');
    list.className = 'mf-desc-tabs__list';
    list.setAttribute('role', 'tablist');
    wrap.append(list);
    heads.forEach((h, i) => {
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'mf-desc-tabs__tab';
      tab.id = `${id}-tab-${i}`;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', `${id}-panel-${i}`);
      tab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      tab.tabIndex = i === 0 ? 0 : -1;
      tab.textContent = h.textContent.trim();
      list.append(tab);
      const panel = document.createElement('div');
      panel.className = 'mf-desc-tabs__panel';
      panel.id = `${id}-panel-${i}`;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      if (i > 0) panel.hidden = true;
      // contenu de l'onglet : tout ce qui suit l'intertitre jusqu'au suivant
      let n = h.nextElementSibling;
      while (n && !heads.includes(n)) {
        const next = n.nextElementSibling;
        panel.append(n);
        n = next;
      }
      h.remove();
      wrap.append(panel);
    });
    desc.append(wrap);
    const tabs = [...list.children];
    const select = (t) => {
      tabs.forEach((x) => {
        const on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        document.getElementById(x.getAttribute('aria-controls')).hidden = !on;
      });
    };
    list.addEventListener('click', (e) => {
      const t = e.target.closest('.mf-desc-tabs__tab');
      if (t) select(t);
    });
    list.addEventListener('keydown', (e) => {
      const i = tabs.indexOf(document.activeElement);
      if (i < 0 || !['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
      const t = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      select(t);
      t.focus();
    });
  };
  const run = () => document.querySelectorAll('.product__description').forEach(build);
  run();
  // la fiche peut être redessinée au changement de taille
  const host = document.querySelector('product-info') || document.querySelector('main');
  let t = 0;
  if (host)
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(run, 30);
    }).observe(host, { childList: true, subtree: true });
})();

/* ---------- Fenêtres « Fiche complète » (18/10) ---------- */
document.addEventListener('click', (e) => {
  const open = e.target.closest('[data-mf-dialog]');
  if (open) {
    const d = document.getElementById(open.dataset.mfDialog);
    if (d && typeof d.showModal === 'function') d.showModal();
    return;
  }
  if (e.target.closest('[data-mf-dialog-close]')) {
    e.target.closest('dialog')?.close();
    return;
  }
  // clic sur le fond assombri : on ferme
  if (e.target instanceof HTMLDialogElement && e.target.classList.contains('mf-sheet-dialog')) e.target.close();
});
